import { render, staticRenderFns } from "./StateGovernmentCheck.vue?vue&type=template&id=01dae91d&scoped=true"
import script from "./StateGovernmentCheck.vue?vue&type=script&lang=js"
export * from "./StateGovernmentCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dae91d",
  null
  
)

export default component.exports